<template>
  <div>
    <p id="requiredMessage" v-if="!formSubmittedSuccessfully">Fields with an <small> * </small> are required</p>
    <p id="thankYouMessage" v-if="formSubmittedSuccessfully">Thank you for your interest in Ampleon. Your submission has been received.</p>
    <form ref="form" @submit.prevent="submitForm" id="subscriptionSubmitForm" method="POST" enctype="multipart/form-data" role="form" v-if="!formSubmittedSuccessfully" novalidate>
      <input type="hidden" id="csrf" name="csrf" :value="csrfToken">
      <div class="form-group" :style="{ marginBottom: formErrors.firstNameError ? '0' : '15px' }">
        <label for="firstName" class="control-label">First Name <small class="required-label">*</small></label>
        <input type="text" class="form-control" id="firstName" name="firstName" v-model="formData.firstName" :class="{'error': formErrors.firstNameError}">
        <p class="error-message" id="firstNameError" v-show="formErrors.firstNameError">This field is required</p>
      </div>
      <div class="form-group" :style="{ marginBottom: formErrors.lastNameError ? '0' : '15px' }">
        <label for="lastName" class="control-label">Last Name <small class="required-label">*</small></label>
        <input type="text" class="form-control" id="lastName" name="lastName" v-model="formData.lastName" :class="{'error': formErrors.lastNameError}">
        <p class="error-message" id="lastNameError" v-show="formErrors.lastNameError">This field is required</p>
      </div>
      <div class="form-group" :style="{ marginBottom: formErrors.emailError ? '0' : '15px' }">
        <label for="email" class="control-label">E-mail <small class="required-label">*</small></label>
        <input type="email" class="form-control" id="email" name="email" v-model="formData.email" :class="{'error': formErrors.emailError}">
        <p class="error-message" id="emailError" v-show="formErrors.emailError">{{this.formErrors.emailError}}</p>
      </div>
      <div class="form-group" :style="{ marginBottom: formErrors.phoneError ? '0' : '15px' }">
        <label for="phone" class="control-label">Phone <small class="required-label">*</small></label>
        <input type="tel" class="form-control" id="phone" name="phone" v-model="formData.phone" :class="{'error': formErrors.phoneError}">
        <p class="error-message" id="phoneError" v-show="formErrors.phoneError">This field is required</p>
      </div>
      <div class="form-group" :style="{ marginBottom: formErrors.countryError ? '0' : '15px' }">
        <label for="country" class="control-label">Country of Residence <small class="required-label">*</small></label>
        <select class="form-control" id="country" name="country" v-model="formData.country" :class="{'error': formErrors.countryError}">
          <option value="">Select</option>
          <option v-for="country in countries" :key="country.code" :value="country.name">{{ country.name }}</option>
        </select>
        <p class="error-message" id="countryError" v-show="formErrors.countryError">This field is required</p>
      </div>
      <div class="form-group">
        <label for="message" class="control-label">Message</label>
        <textarea class="form-control" id="message" name="message" rows="10" v-model="formData.message"></textarea>
      </div>
      <div class="form-group-file-upload" id="attachments">
        <div class="custom-file-upload" :style="{ marginBottom: formErrors.lastNameError ? '0' : '30px' }">
          <label for="fileUploadCV" class="control-label">Upload Resume/CV <small v-if="isCvRequired" class="required-label">*</small></label>
          <input type="file" @change="handleFileUpload($event, 'CV')" id="fileUploadCV" name="fileUploadCV" class="file-input" :required="isCvRequired" hidden>
          <span class="file-info">{{ fileChosenCV }}</span>
          <p class="error-message" id="fileUploadCVError" v-show="formErrors.fileUploadCVError">This field is required</p>
        </div>
        <div class="custom-file-upload">
          <label for="fileUploadMotivation" class="control-label">Upload Cover Letter</label>
          <input type="file" @change="handleFileUpload($event, 'Motivation')" id="fileUploadMotivation" name="fileUploadMotivation" class="file-input" hidden>
          <span class="file-info">{{ fileChosenMotivation }}</span>
        </div>
      </div>
      <div class="form-group-checkbox">
        <input type="checkbox" id="subscribe" name="subscribe" value="Yes" v-model="formData.subscribe"
               data-gtm-form-interact-field-id="0">
        <label for="subscribe">I give permission to archive my personal information for 1 year
          in the Ampleon talent pool</label>
      </div>
      <div class="form-group-checkbox">
        <input type="checkbox" id="termsOfUse" name="termsOfUse" value="Yes" v-model="formData.termsOfUse">
        <label for="termsOfUse">
          I have read and accept the <a :href="termsOfUseUrl" target="_blank">Terms of Use</a> and
          <a :href="privacyPolicyUrl" target="_blank">Privacy Policy</a>
          <small class="required-label">*</small>
        </label>
      </div>
      <p class="error-message" id="termsOfUseError" v-show="formErrors.termsOfUseError">This field is required</p>
      <p class="file-erors" v-show="formErrors.fileCVFormatError">{{ `Extension [${fileCVExtension}] not supported
            Supported file extensions: pdf, doc, docx, txt, rtf` }}</p>
      <p class="file-erors" v-show="formErrors.fileMotivationFormatError">{{ `Extension [${fileChosenMotivation}] not supported.
            Supported file extensions: pdf, doc, docx, txt, rtf` }}</p>
      <p class="file-erors" v-show="formErrors.fileCVSizeError">{{ `The size of the file (${fileCVSizeMB}MB) exceeds the maximum file size (10MB)` }}</p>
      <p class="file-erors" v-show="formErrors.fileMotivationSizeError">{{ `The size of the file (${fileMotivationSizeMB}MB) exceeds the maximum file size (10MB)` }}</p>
<!--      <ReCaptchaTerms></ReCaptchaTerms>-->
      <button type="submit" id="submitForm" >Submit Application</button>
    </form>
  </div>
</template>

<script>
// import ReCaptchaTerms from "./ReCaptchaTerms";

export default {
  name: 'ContactForm',

  // components: {
  //   ReCaptchaTerms
  // },

  props: {
    countryProp: {
      type: Array,
      default: function () {
        return [
          { name: 'Albania', code: 'AL' },
          { name: 'Germany', code: 'DE' },
          { name: 'United States', code: 'US' },
        ];
      }
    },
    isCvRequired: {
      type: Boolean,
      default: false
    },
    termsOfUseUrl: {
      type: String,
      default: '/about/terms-of-use.html'
    },
    privacyPolicyUrl: {
      type: String,
      default: '/about/privacy.html'
    },
    csrfToken: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        message: '',
        fileUploadCV: null,
        fileUploadMotivation: null,
        subscribe: false,
        termsOfUse: false,
        // recaptchaResponse: '',
      },
      formErrors: {
        firstNameError: false,
        lastNameError: false,
        emailError: '',
        phoneError: false,
        countryError: false,
        fileUploadCVError: false,
        termsOfUseError: false,
        fileCVFormatError: false,
        fileMotivationFormatError: false,
        fileCVSizeError: false,
        fileMotivationSizeError: false,
      },
      formSubmittedSuccessfully: false,
      fileChosenCV: "No file chosen",
      fileChosenMotivation: "No file chosen",
      fileCVExtension: '',
      fileMotivationExtension: '',
      fileCVSizeMB: '',
      fileMotivationSizeMB: '',
      countries: this.countryProp
    };
  },

  methods: {
    submitForm() {
      event.preventDefault();

      this.formErrors.firstNameError = !this.formData.firstName;
      this.formErrors.lastNameError = !this.formData.lastName;
      this.formErrors.phoneError = !this.formData.phone;
      this.formErrors.countryError = !this.formData.country;
      this.formErrors.termsOfUseError = !this.formData.termsOfUse;

      if (this.isCvRequired) {
        this.formErrors.fileUploadCVError = !this.formData.fileUploadCV;
      } else {
        this.formErrors.fileUploadCVError = false;
      }

      if (!this.formData.email) {
        this.formErrors.emailError = 'This field is required';
      } else if (!this.formData.email.includes('@')) {
        this.formErrors.emailError = 'This e-mail address is missing an @';
      } else {
        this.formErrors.emailError = '';
      }

        if (Object.values(this.formErrors).some(error => error)) {
          return;
        }

        // this.formData.recaptchaResponse = await this.$recaptcha('contactForm');
        //
        // const recaptchaInput = document.createElement('input');
        // recaptchaInput.type = 'hidden';
        // recaptchaInput.name = 'token';
        // recaptchaInput.value = this.formData.recaptchaResponse;
        // this.$refs.form.appendChild(recaptchaInput);

        console.log(this.formData);
        // event.target.submit();
        this.$refs.form.submit();
        this.formSubmittedSuccessfully = true;
    },

    handleFileUpload(event, type) {
      const file = event.target.files[0];
      const maxFileSize = 10485760;

      if (!file) {
        if (type === 'CV') {
          this.fileChosenCV = "No file chosen";
          this.formData.fileUploadCV = null;
          this.formErrors.fileCVSizeError = false;
          this.formErrors.fileCVFormatError = false;
          // Only set error if isCvRequired is true
          this.formErrors.fileUploadCVError = this.isCvRequired;
        } else if (type === 'Motivation') {
          this.fileChosenMotivation = "No file chosen";
          this.formData.fileUploadMotivation = null;
          this.formErrors.fileMotivationSizeError = false;
          this.formErrors.fileMotivationFormatError = false;
        }
        return;
      }

      let fileSizeMB = (file.size / 1048576).toFixed(2);

      if (type === 'CV') {
        this.formData.fileUploadCV = file;
        this.fileCVSizeMB = fileSizeMB;
        this.fileChosenCV = file.name;
      } else if (type === 'Motivation') {
        this.formData.fileUploadMotivation = file;
        this.fileMotivationSizeMB = fileSizeMB;
        this.fileChosenMotivation = file.name;
      }

      // Size check
      if (file.size > maxFileSize) {
        if (type === 'CV') {
          this.formErrors.fileCVSizeError = true;
          this.formData.fileUploadCV = null;
          this.fileChosenCV = `File too large: ${fileSizeMB} MB`;
        } else if (type === 'Motivation') {
          this.formErrors.fileMotivationSizeError = true;
          this.formData.fileUploadMotivation = null;
          this.fileChosenMotivation = `File too large: ${fileSizeMB} MB`;
        }
        return;
      } else {
        this.formErrors.fileCVSizeError = false;
        this.formErrors.fileMotivationSizeError = false;
      }

      // File format validation
      const allowedExtensions = /(\.pdf|\.doc|\.docx|\.txt|\.rtf)$/i;
      if (!allowedExtensions.exec(file.name)) {
        const fileExtension = file.name.split('.').pop();
        if (type === 'CV') {
          this.formErrors.fileCVFormatError = true;
          this.fileCVExtension = fileExtension;
          this.formData.fileUploadCV = null;
          this.fileChosenCV = `Invalid file format: .${fileExtension}`;
        } else if (type === 'Motivation') {
          this.formErrors.fileMotivationFormatError = true;
          this.fileMotivationExtension = fileExtension;
          this.formData.fileUploadMotivation = null;
          this.fileChosenMotivation = `Invalid file format: .${fileExtension}`;
        }
      } else {
        this.formErrors.fileCVFormatError = false;
        this.formErrors.fileMotivationFormatError = false;
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

#requiredMessage {
  display: flex;
  margin-bottom: 5px;
  margin-left: 15px;

  small {
    margin-left: 2px;
    margin-right: 2px;
  }
}

#subscriptionSubmitForm {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-right: 15px;

  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;

    .error-message {
      align-self: start ;
      padding-top: 5px
    }
  }

  .form-group-checkbox {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 10px;

    label {
      margin-left: 5px;
      font-weight: 700;
      text-align: left;
    }

    a {
      text-decoration: none;
      color: #337AB7;
    }

    small {
      margin-left: 5px;
    }
  }
}

.form-control {
  padding: 8px;

  &.error {
    border-color: red;
  }
}

.error-message {
  color: red !important;
}

label {
  align-self: start;
  font-weight: 700;
  margin-bottom: 5px;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.3s, color 0.3s, text-decoration 0.3s;
  outline: none;
}

#submitForm {
  border-radius: 0;
  padding: 10px 20px;
  background-color: #00a8e1;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s, text-decoration 0.3s;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  align-self: start;
  border: 1px solid #00a8e1;

  &:active {
    background-color: #00a8e1;
    color: white;
  }

  &:hover, &:focus, &:visited {
    background-color: white;
    color: #00a8e1;
    text-decoration: none;
  }
}

#thankYouMessage {
  font-size: 1rem;
  padding-left: 15px;
}

small {
  color: red;
}

.form-group-file-upload {
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;

  .custom-file-upload {
    margin-right: 20px;
    margin-bottom: 30px;

    label {
      background-color: white;
      color: #00a8e1;
      padding: 0.8rem;
      font-family: sans-serif;
      border: 1px solid #00a8e1;
      cursor: pointer;
      margin-top: 1rem;
      margin-right: 20px;
      font-size: 14px;
      font-weight: lighter;

      &:hover, &:focus, &:visited {
        background-color: #00a8e1;
        color: white;
        text-decoration: none;
      }
    }

    .error-message {
      align-self: start !important;
      margin-top: 0 !important;
    }
  }
}

.file-erors {
  color: red;
  align-self: start;
}

.error {
  border-color: red !important;
}
#termsOfUseError {
  margin-top: -5px !important;
}

#fileUploadCVError {
  text-align: left;
  margin-top: 1rem;
}

.file-input {
  display: none !important;
}

</style>
